export default __webpack_public_path__ + "static/media/logo.f67f711b.svg";